exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".empty-state{padding:48px 32px;text-align:center;color:var(--meridian-color-text-secondary,#666);display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:200px}.empty-state .empty-state-message{font-size:16px;line-height:1.5;max-width:500px;margin:0 auto}", ""]);

// exports
